<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-muted text-center mb-3">
                <small>Sign in with</small>
              </div>
              <template>
                <div id="customBtn" v-google-signin-button class="g-signin2 d-flex justify-content-center mb-3">
                  <div class="google-btn">
                    <div class="google-icon-wrapper">
                      <img class="google-icon" src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"/>
                    </div>
                    <p class="btn-text"><b>Login</b></p>
                  </div>
                </div>
              </template>
            </template>

            <template>
              <div class="text-center text-muted mb-4">
                <small>Or sign in with credentials</small>
              </div>
              <form role="form">
                <base-input
                  v-model="email.value"
                  alternative
                  :class="email.errors.length && 'input-error'"
                  class="mb-3"
                  placeholder="Email"
                  addon-left-icon="ni ni-email-83"
                >
                </base-input>

                <ul class="form-errors">
                  <li v-for="(error, index) in email.errors" :key="index">
                    {{ error }}
                  </li>
                </ul>

                <base-input
                  v-model="password.value"
                  alternative
                  :class="password.errors.length && 'input-error'"
                  type="password"
                  placeholder="Password"
                  addon-left-icon="ni ni-lock-circle-open"
                >
                </base-input>

                <ul class="form-errors">
                  <li v-for="(error, index) in password.errors" :key="index">
                    {{ error }}
                  </li>
                </ul>

                <base-checkbox>
                  Remember me
                </base-checkbox>
                <div class="text-center">
                  <base-button type="submit" @click="submitForm" class="my-4"
                    >Sign In</base-button
                  >
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <small>Forgot password?</small>
              </a>
            </div>
            <div class="col-6 text-right">
              <a href="#" class="text-light">
                <small>Create new account</small>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Cookies from "../utils/Cookies";
import router from "../router.js";
// import store from "@/store"

export default {
  data: () => ({
    email: {
      value: Cookies.read("new_user"),
      errors: []
    },
    password: {
      value: null,
      errors: []
    }
  }),
  methods: {
    OnGoogleAuthSuccess (googleUser, idToken) {
      // Receive the idToken and make your magic with the backend
      const url = process.env.VUE_APP_API_URL + "/googletoken";
      const body = {
        id_token: idToken,
        name: googleUser.getBasicProfile().getName(),
      };
      console.log(body);

      console.log('/googletoken');
      fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, cors, *same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(body) // body data type must match "Content-Type" header
      })
        .then(res => res.json())
        .then(data => {
          const { status, message, token, ...userData } = data;
          if(!status) {
            this.handleLoginError(message, status);
            return;
          }

          if (token) {
            // Cookies.create("token", token, null);
            // //console.log(id, token, Role);
            // localStorage.setItem("token", token);

            // this.$store.dispatch("LOGIN", data);
            console.log('isauth=', this.$store.getters.isAuthenticated);
            console.log('user=', this.$store.getters.user);
            this.$store.dispatch('setToken', token);
            this.$store.dispatch('setUser', userData);
            console.log('isauth=', this.$store.getters.isAuthenticated);
            console.log('user=', this.$store.getters.user);


            router.push("/");
          }
        })
        .catch(error => {
          this.handleLoginError(error, {})
        });
    },
    OnGoogleAuthFail (error) {
      console.log(error)
    },

    validEmail: function(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    isValidForm() {
      this.email.errors = [];
      this.password.errors = [];

      if (!this.email.value) {
        this.email.errors.push("Email required.");
      } else if (!this.validEmail(this.email.value)) {
        this.email.errors.push("Invalid email.");
      }

      if (!this.password.value) {
        this.password.errors.push("Password required.");
      }

      if (this.password.errors.length || this.email.errors.length) {
        return false;
      }

      return true;
    },
    async submitForm() {
      if (!this.isValidForm()) {
        return;
      }

      const user = {
        Email: this.email.value,
        Password: this.password.value
      };

      const url = process.env.VUE_APP_API_URL + "/login";
      console.log('fetch=',url)
      fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, cors, *same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(user) // body data type must match "Content-Type" header
      })
        .then(res => res.json())
        .then(data => {
          const { status, message, token, ...userData } = data;
          if(!status) {
            console.log(message)
            this.password.errors.push(message)
            this.handleLoginError(message, status);
            return;
          }

          if (token) {
            // Cookies.create("token", token, null);
            // //console.log(id, token, Role);
            // localStorage.setItem("token", token);

            // this.$store.dispatch("LOGIN", data);
            console.log('isauth=', this.$store.getters.isAuthenticated);
            console.log('user=', this.$store.getters.user);
            this.$store.dispatch('setToken', token);
            this.$store.dispatch('setUser', userData);
            console.log('isauth=', this.$store.getters.isAuthenticated);
            console.log('user=', this.$store.getters.user);


            router.push("/");
          }
        })
        .catch(error => {
          console.log("error trying to login")
          this.handleLoginError(error, {})
        });
    },

    handleLoginError(error, more) {
      console.error("login error");
      console.error(error);
      console.error(more);
    },
  }
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500&display=swap');

.form-errors {
  color: red;
}
div.input-error {
  border: 1px solid red;
}

.google-btn {
  width: 120px;
  height: 36px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}
.google-btn .google-icon-wrapper {
  position: absolute;
  /* margin-top: 1px;
  margin-left: 1px; */
  width: 40px;
  height: 40px;
  border-radius: 2px;
  /* background-color: #fff; */
}
.google-btn .google-icon {
  position: absolute;
  margin-top: 8px;
  margin-left: 8px;
  width: 18px;
  height: 18px;
}
.google-btn .btn-text {
  float: right;
  margin: 6px 26px 0 0;
  font-family: Roboto, arial, sans-serif;
  font-weight: 300;
  font-size: 13px;
  letter-spacing: 0.21px;
}
.google-btn:hover {
  box-shadow: 0 0 6px #4285f4;
  cursor: pointer;
}
</style>
